import React, { Dispatch, ReactNode, SetStateAction } from "react";
import { List, PaginationProps } from "antd";
import { BaseItem } from "common/interfaces";

interface PaginateListMobileProps<T extends BaseItem> {
  selectedRowKeyMobile?: string[];
  setSelectedRowKeyMobile?: Dispatch<SetStateAction<string[]>>;
  pagination?: PaginationProps | false;
  dataSource: T[];
  renderItem: (
    item: T,
    checked: boolean,
    onSelect: (code: string, checked: boolean) => void,
  ) => ReactNode;
}

export function PaginateListMobile<T extends BaseItem>({
  selectedRowKeyMobile,
  setSelectedRowKeyMobile,
  pagination,
  dataSource,
  renderItem,
}: PaginateListMobileProps<T>) {
  const onSelect = (code: string, checked: boolean) => {
    setSelectedRowKeyMobile &&
      setSelectedRowKeyMobile((prev: string[]) =>
        checked ? [...prev, code] : prev.filter((key) => key !== code),
      );
  };

  return (
    <div className="self-stretch inline-flex flex-col justify-start items-start gap-3.5 md:hidden">
      <List
        dataSource={dataSource}
        pagination={pagination}
        renderItem={(item: T) => {
          const checked =
            (selectedRowKeyMobile &&
              selectedRowKeyMobile.includes(item.code)) ||
            false;
          return <List.Item>{renderItem(item, checked, onSelect)}</List.Item>;
        }}
      />
    </div>
  );
}

export default PaginateListMobile;
